import { useTranslate } from "@refinedev/core";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en",
    supportedLngs: ["en"],
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
    fallbackLng: "en",
  });

export default i18n;

export type TFunction = ReturnType<typeof useTranslate>;
